<template>
  <div class="container"  :class="{'section-loading': isLoading}">
    
    <div class="row">
      <div class="col-12">
        <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-1" value="1">
            <label for="search-type-1">發佈中</label>
        </div>
        <div class="radio radio-inline">
            <input type="radio" v-model="searchType" id="search-type-2" value="2">
            <label for="search-type-2">已下架</label>
        </div>
        <hr>
      </div>
    </div>
    <div class="row" v-if="searchType==1">
     <!-- <div class="row" v-if="tableData.queryClickRateList.length > 0">   -->
      <table v-if="releaseShow" class="table datatable insurance-green table-striped table-bordered">
        <thead>
           <tr>
            <th class="sorting text-left"
            :class="(order.queryClickRateList.fieldName=='subject' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'subject')">
                主旨
            </th>
            <th class="sorting text-center"
            style="min-width: 150px;"
            :class="(order.queryClickRateList.fieldName=='upd_nm' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'upd_nm')">
                最後一次編輯者
            </th>
            <th class="sorting text-center"
            style="min-width: 100px;"
            :class="(order.queryClickRateList.fieldName=='star_date' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'star_date')">
                發佈日期
            </th>
            <th class="sorting text-center"
            style="min-width: 100px;"
            :class="(order.queryClickRateList.fieldName=='end_date' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'end_date')">
                下架日期
            </th>
            <th class="sorting text-center"
            style="min-width: 150px;"
            :class="(order.queryClickRateList.fieldName=='ta_count' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'ta_count')">
                受眾人數
            </th>
            <th class="sorting text-center"
            style="min-width: 100px;"
            :class="(order.queryClickRateList.fieldName=='click_percentage' ? (order.queryClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('queryClickRateList', 'click_percentage')">
                點閱率
            </th>
            <th class="text-center" style="min-width: 100px;">功能</th>
          </tr>
        </thead>
        <tbody v-if="tableData.queryClickRateList.length > 0">
          <tr v-for="(row, rid) in tableData.queryClickRateList" :key="`row-${rid}`">
              <td>
                  <a class="pointer-cursor text-underline text-green" @click="lookupBulletinBoard(row)">{{row.subject}}</a>
              </td>
              <td class="text-center">
                  {{row.upd_nm}}
              </td>
              <td class="text-center">
                  {{row.star_date | dateFormat }}
              </td>
              <td class="text-center">
                  {{row.end_date | dateFormat }}
              </td>
              <td class="text-center">
                  {{row.ta_count}}
              </td>
              <td class="text-center">
                  {{row.click_percentage}}%
              </td>
              <td class="line-height-2 text-center">
                  <a @click="effectiveness(row)" class="link text-underline">成效</a> <br />
                  <a @click="openEditModal(row)" class="link text-underline">修改</a>
              </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="7" class="empty-block bg-white">
              <h3 class="bg-white">查無資料</h3>
            </td>
          </tr>
        </tbody>        
      </table>
      <p>點閱率=受眾點擊人數/受眾人數</p>   
    </div>
    <div class="row" v-show="searchType=='2'">
      <div class="col-12">
        <form class="form">
          <div class="form-group row">
            <label class="pl-2 text-right">月份</label>
            <div class="col-11">
              <select class="form-control form-control-inline form-short" v-model="exclusionForm.startYear">
              <option
              v-for="(year, yearIndex) in yearOpt"
              :key="`service-year-${yearIndex}`"
              :value="year.value">{{year.text}}</option>
              </select>
              <span class="text">/</span>
              <select type="text" class="form-control form-control-inline form-short" v-model="exclusionForm.startMonth">
              <option
              v-for="(month, monthIndex) in monthOpt"
              :key="`service-month-${monthIndex}`"
              :value="month.value">{{month.text}}</option>
              </select>
              <span class="text">～</span>
              <select class="form-control form-control-inline form-short" v-model="exclusionForm.endYear">
              <option
              v-for="(year, yearIndex) in yearOpt"
              :key="`service-year-${yearIndex}`"
              :value="year.value">{{year.text}}</option>
              </select>
              <span class="text">/</span>
              <select type="text" class="form-control form-control-inline form-short"  v-model="exclusionForm.endMonth">
              <option
              v-for="(month, monthIndex) in monthOpt"
              :key="`service-month-${monthIndex}`"
              :value="month.value">{{month.text}}</option>
              </select>
              <input type="text" class="form-control form-control-inline" v-model="subjectKeyWord">
              <button type="button" class="btn btn-primary mt-0" @click="submitDate()">查詢</button>
            </div>
          </div>
        </form>
        <div class="row" v-if="tableData.queryOldClickRateList.length > 0">
          <table v-if="offlineShow"  class="table datatable insurance-green table-striped table-bordered">
            <thead>
              <tr>
                <th class="sorting text-left"
                :class="(order.queryOldClickRateList.fieldName=='subject' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'subject')">
                    主旨
                </th>
                <th class="sorting text-center"
                style="min-width: 150px;"
                :class="(order.queryOldClickRateList.fieldName=='upd_nm' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'upd_nm')">
                    最後一次編輯者
                </th>
                <th class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.queryOldClickRateList.fieldName=='star_date' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'star_date')">
                    發佈日期
                </th>
                <th class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.queryOldClickRateList.fieldName=='end_date' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'end_date')">
                    下架日期
                </th>
                <th class="sorting text-center"
                style="min-width: 150px;"
                :class="(order.queryOldClickRateList.fieldName=='ta_count' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'ta_count')">
                    受眾人數
                </th>
                <th class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.queryOldClickRateList.fieldName=='click_percentage' ? (order.queryOldClickRateList.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting('queryOldClickRateList', 'click_percentage')">
                    點閱率
                </th>
                <th class="text-center" style="min-width: 100px;">功能</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rid) in tableData.queryOldClickRateList" :key="`row-${rid}`">
                  <td>
                      <a class="pointer-cursor text-underline text-green" @click="lookupBulletinBoard(row)">{{row.subject}}</a>
                  </td>
                  <td class="text-center">
                      {{row.upd_nm}}
                  </td>
                  <td class="text-center">
                      {{row.star_date | dateFormat}}
                  </td>
                  <td class="text-center">
                      {{row.end_date | dateFormat}}
                  </td>
                  <td class="text-center">
                      {{row.ta_count}}
                  </td>
                  <td class="text-center">
                      {{row.click_percentage}}%
                  </td>  
                  <td class="line-height-2 text-center">
                      <a @click="effectiveness(row)" class="link text-underline">成效</a> <br />
                      <a @click="openEditModal(row)" class="link text-underline" :disabled="isdisabledFn()">修改</a>
                  </td>
              </tr>
            </tbody>
          </table>
           <p>點閱率=受眾點擊人數/受眾人數<br />
           下載/點擊率=受眾下載附件或點擊連結人數/受眾人數</p>
        </div>
        <div v-else class="empty-block w-100">
          <span>無任何查詢結果。</span>
        </div>
      </div>
    </div>
    <bulletin-board-modal
    :open="BulletinBoardModalOpen"
    :bulletin_board_data="bulletin_board_data"
    :modal_title="modal_title"
    :isEdit="is_edit"
    :type-status="searchType"
    @refresh="initial"
    @close="panelClose('BulletinBoardModalOpen')"

     />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import DataTable from '@/components/DataTable/DataTableCollapse'
import {commonMixin} from '@/mixins/common'
import { getBulletinBoardMeesage ,queryClickRate ,queryOldClickRate } from '@/service'
import BulletinBoardModal from './BulletinBoardModal'

export default {
  name: 'ClickRateView',
  mixins: [commonMixin],
  components: {
    DataTable, BulletinBoardModal
  },
  props: {
    'status': String
  },
  watch: {
    'searchType': function () {
        this.initial()
    },
  },
  data () {
    return {
      isLoading: false,
      releaseShow: true,
      offlineShow: true,
      searchType: '1',
      tableData: {
        queryClickRateList:[],
        queryOldClickRateList:[]
      },
      yearOpt: [],
      monthOpt: [],
      exclusionForm:{
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      }, 
      subjectKeyWord:'',           
      order: {
        queryClickRateList: {
          fieldName: 'subject',
          asc: true
        },
        queryOldClickRateList: {
          fieldName: 'subject',
          asc: true
        }
      },
      BulletinBoardModalOpen: false,
      // EffectivenessOpen: false,
      modal_title: '最後一次編輯者:',
      bulletin_board_data: {},
      is_edit: false,
    }
  },
  methods: {
    ...mapActions([
      'setPageLock', 'updaBulletinSerNo'
    ]),
    changeType (val) {
      this.order.currentTable = Number(val)
    },
    columnSorting(target, fieldName) {
      if(this.tableData[target].length == 0) {
        return;
      }

      //切換表頭圖案
      if (this.order[target].fieldName == fieldName) {
          this.order[target].asc = !this.order[target].asc
      } else {
          this.order[target].asc = true
      }
      this.order[target].fieldName = fieldName

      //data排序
      console.log('target',target)
      // this.tableData[target] = []
      const vm = this
      vm.releaseShow = false
      vm.offlineShow = false
      vm.tableData[target].sort(vm.compareValues(fieldName, vm.order[target].asc))
      setTimeout(() => {
        vm.releaseShow = true
        vm.offlineShow = true
        vm.registerHanlink() // for 難字
      }, 50)
    },
    compareValues(key, isAsc) {
      let order = isAsc? 1: -1;
      return function(a, b) {
        let result = a[key] < b[key] ? -1 : 1
        return result * order
      }
    },
    isdisabledFn(){
          let aDate,bDate, oDate1, oDate2,iDays
        this.tableData.queryOldClickRateList.forEach((item)=>{
          aDate = item.star_date.split('-')
          bDate = item.end_date.split('-')
        })
        oDate1 = new Date(aDate.join('/')).getTime()
        oDate2 = new Date(bDate.join('/')).getTime()
        iDays = parseInt((oDate2 - oDate1) / 1000 / 60 / 60 / 24)
      if(iDays > 390){ //13個月 = 13*30
        return true
      }else{
        return false
      }
    },
    submitDate() {
       this.initial()
    },
    effectiveness(data) {
      this.updaBulletinSerNo(data.ser_no)
      this.$emit('change-status','STATUS_EFFECTIVENESS',data) 
    },
    openEditModal(data) {
      this.is_edit = true;
      this.bulletin_board_data = data
      this.panelOpen('BulletinBoardModalOpen');
    },
  
    lookupBulletinBoard(data) {
      this.is_edit = false;
      this.bulletin_board_data = data

      this.panelOpen('BulletinBoardModalOpen');
    },
    initial(){
      if(this.searchType==1){
        this.isLoading = true
        queryClickRate(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo).then(result => { //點閱率查詢
          this.isLoading = false
          if(result.header && result.header.status === '200') {
              this.tableData.queryClickRateList = result.body.report.map(ele => {
                ele['click_percentage'] = ele.percentage_list.click_percentage
                return ele
              })
          } else {
            this.tableData.queryClickRateList = []
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '初始化失敗,請重新操作'})
            }
          }
          this.registerHanlink() // for 難字
        })      
      }else{
        this.isLoading = true
        let lastDay = new Date(this.exclusionForm.endYear, parseInt(this.exclusionForm.endMonth), 0).getDate(); //取每月最後一天
        let startDate = `${this.exclusionForm.startYear}-${this.exclusionForm.startMonth}-01`
        let endDate = `${this.exclusionForm.endYear}-${this.exclusionForm.endMonth}-${lastDay}`  
        this.tableData.queryOldClickRateList = []      
        queryOldClickRate(this.$store.state.userInfo.id,this.$store.state.userInfo.divNo,startDate,endDate,this.subjectKeyWord).then(result => { //下架點閱率查詢
          this.isLoading = false     
          if(result.header && result.header.status === '200') {
              this.tableData.queryOldClickRateList = result.body.report
          } else {
            this.tableData.queryOldClickRateList = []
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '初始化失敗,請重新操作'})
            }
          }
          this.registerHanlink() // for 難字
        })   
        
      }
    },
    initMonthOpt() { //月份預設為上個月
      for(var i=1; i<13; i++) {
        let selectItem = {
          value: String(i).length == 1 ? '0' + String(i) : String(i),
          text: `${i}月`
        }
        this.monthOpt.push(selectItem)
      }

    },
    initYearOpt() {
      let westYear = new Date().getFullYear()
      for(var i=westYear-5; i<=westYear; i++) {
        let selectItem = {
          value: String(i),
          text: `${i - 1911}年`
        }
        this.yearOpt.push(selectItem)
      }
      this.yearOpt.reverse()


      //  初始化日期區間
      let nowDate = this.getCurrentDate().split('-')
      if(nowDate[1] - 1 > 0) {
        this.exclusionForm.startMonth = (nowDate[1] - 1 + '').length == 1 ? '0' + (nowDate[1] - 1 + '') : (nowDate[1] - 1 + '')
        this.exclusionForm.endMonth = (nowDate[1] - 1 + '').length == 1 ? '0' + (nowDate[1] - 1 + '') : (nowDate[1] - 1 + '')
        this.exclusionForm.startYear = nowDate[0]
        this.exclusionForm.endYear = nowDate[0]
      } else {
        this.exclusionForm.startMonth = (nowDate[1] - 1 + 12 + '').length == 1 ? '0' + (nowDate[1] - 1 + 12 + '') : (nowDate[1] - 1 + 12 + '')
        this.exclusionForm.endMonth = (nowDate[1] - 1 + 12 + '').length == 1 ? '0' + (nowDate[1] - 1 + 12 + '') : (nowDate[1] - 1 + 12 + '')
        this.exclusionForm.startYear = nowDate[0] - 1 + ''
        this.exclusionForm.endYear = nowDate[0] - 1 + ''
      } 

    },    
  },
  mounted () {
    this.initMonthOpt()
    this.initYearOpt()    
    this.initial()
  }
}
</script>
